import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex';
import Hamburger from '@/components/Hamburger';
import NavbarRight from "../components/NavbarRight";
export default {
  components: {
    Hamburger: Hamburger,
    NavbarRight: NavbarRight
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    slideClass: function slideClass(state) {
      return state.settings.slideClass;
    }
  })), mapGetters(['sidebar'])),
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    }
  }
};